





































































import {
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import { GroupMember, GroupMemberWithEmail } from '@front-app/services/UserApi/UserModel';
import { UserStore } from '@front-app/store/singletons/User';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import Pagination from '@front-app/components/Pagination.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import MemberInvitationsModal from '@front-app/modules/groupMember/components/MemberInvitationsModal.vue';
import GroupMemberCard from './GroupMemberCard.vue';

export default defineComponent({
	components: {
		LoaderState,
		ErrorCard,
		MemberInvitationsModal,
		Pagination,
		SlidingPanel,
		GroupMemberCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		numPages: {
			type: Number,
			required: true,
		},
		currentPage: {
			type: Number,
			required: true,
		},
		members: {
			type: Array as PropType<Array<GroupMember | GroupMemberWithEmail>>,
			required: true,
		},
		hasNextPage: Boolean,
		hasPrevPage: Boolean,
		isLoadingMembers: Boolean,
		hasNotFetchedMembers: Boolean,
		hasErrorLoadingMembers: Boolean,
	},
	setup() {
		const { getFullUser } = UserStore.getInstance();

		const isMemberInvitationsModalOpen = ref(false);
		const selectedMember: Ref<null | GroupMemberWithEmail | GroupMember> = ref(null);
		const openMemberInvitationsModal = (member: GroupMemberWithEmail | GroupMember) => {
			selectedMember.value = member;
			isMemberInvitationsModalOpen.value = true;
		};

		return {
			getFullUser,
			// Member invitations modal
			isMemberInvitationsModalOpen,
			openMemberInvitationsModal,
			selectedMember,
		};
	},
});
